<template>
    <div>
        <modal-live
            ref="modal"
            :default-show-modal="false"
            :dismiss-on-overlay="false"
        >
            <div class="modal-header">
                <h3 class="headline--modal">Truck Presets</h3>
                <span class="modal__icon-close" @click="close()">
                    <svg>
                        <use :xlink:href="`${icons['close']}#icon`"></use>
                    </svg>
                </span>
            </div>
            <div class="dialog pt-0">
                <h2 class="headline--welcome text-center">
                    Select Truck Preset
                </h2>
                <div>
                    <div v-for="(group, groupkey) in options" :key="groupkey">
                        <div
                            v-for="option in group"
                            :key="option.id"
                            class="d-flex mb-1"
                        >
                            <Button
                                :type="'outline-fine'"
                                @click.native="selectPreset($event, option)"
                                class="flex-fill"
                                :class="[{ active: option.value === selected }]"
                            >
                                {{ option.label }}
                                <span
                                    v-if="option.value !== 'car'"
                                    class="preset-edit"
                                    @click="showPresetDetail(option)"
                                    >Edit</span
                                >
                            </Button>
                        </div>
                    </div>
                </div>

                <div class="text-center pt-3 d-flex" style="gap: 15px">
                    <Button
                        @click.native="showPresetDetail()"
                        class="flex-fill"
                    >
                        Add a preset
                    </Button>
                </div>
            </div>
        </modal-live>
        <truck-preset-detail ref="presetDetail"></truck-preset-detail>
    </div>
</template>

<script>
export default {
    props: ['options', 'selected'],
    data() {
        return {
            icons: window.here.icons,
        };
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        showNew() {
            this.$refs.newPreset.show();
        },
        close() {
            this.$refs.modal.close();
        },
        dismiss() {
            this.$refs.modal.dismiss();
        },
        selectPreset(event, preset) {
            if (!event.target.classList.contains('preset-edit')) {
                this.$emit('selectPreset', preset.value);
                this.$gtag.event('TRUCK_PRESETS_SELECT', {
                    event_category: 'PLAN',
                    value: preset.label,
                });
                this.$refs.modal.close();
            }
        },
        showPresetDetail(preset) {
            if (preset) {
                this.$gtag.event('TRUCK_PRESETS_EDIT', {
                    event_category: 'PLAN',
                    value: preset.label,
                });
            } else {
                this.$gtag.event('TRUCK_PRESETS_ADD', {
                    event_category: 'PLAN',
                });
            }
            this.$refs.presetDetail.show(preset);
        },
    },
};
</script>

<style lang="scss">
.modal-header {
    border-bottom: 0;
    padding-top: 35px;
    padding-bottom: 16px;
    padding-left: 35px;
    padding-right: 35px;
}

.headline--modal {
    font-size: 20px;
    color: #958983;
    margin-bottom: 0;
}

.modal__icon-close {
    color: rgba(78, 58, 48, 0.2);
    cursor: pointer;
    transition: color 0.3s;
    position: absolute;
    top: 16px;
    right: 16px;

    svg {
        width: 40px;
        height: 40px;
    }

    &:hover {
        color: rgba(78, 58, 48, 0.6);
    }
}

.preset-edit {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    color: rgba(78, 58, 48, 0.2);

    &:hover {
        color: #004ecb;
    }
}

.dialog {
    max-height: 65vh;
    overflow-y: auto;

    table {
        border-spacing: 10px;
        border-collapse: separate;
    }
}

.edit-preset__title {
    font-size: 18px;
    color: rgba(78, 58, 48, 1);
}
</style>
